import { gsap } from "gsap";
import { ScrollToPlugin, Power4 } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);

document.addEventListener('DOMContentLoaded', function() {
window.scrollTo(0, 0);

/*
	if (browser) {
        document.documentElement.classList.add(browser.name);
    }

*/
    const cover = document.getElementById('cover');

    const init = function() {
        document.documentElement.classList.add('is-loaded');

        setTimeout(function() {
            cover.remove();
            document.body.classList.remove('no-overflow');

            if (window.location.hash) {
                gsap.to(window, {
                    duration: 1.5,
                    scrollTo: { y: window.location.hash, offsetY: 100 },
                    ease: Power4.easeOut
                });
            }
        }, 500);

        document.getElementById('heroSwiper') ? ctme.Carousel.heroCarousel() : false;
        document.getElementById('brandsSwiper') ? ctme.Carousel.brandsCarousel() : false;
        document.getElementById('officeSwiper') ? ctme.Carousel.officeCarousel() : false;
        document.getElementById('restaurantsSwiper') ? ctme.Carousel.restaurantsCarousel() : false;
        document.getElementById('peopleSwiper') ? ctme.Carousel.peopleCarousel() : false;
        document.getElementsByClassName('js-mobileSwiper').length > 0 ? ctme.Carousel.mobileCarousel() : false;
        document.getElementById('social') ? ctme.Carousel.social() : false;
        ctme.Helper.rwd();
        ctme.Helper.blazy();
        ctme.Nav.init();
        document.getElementById('peopleSwiper') ? ctme.Helper.onloadOpenStory() : false;
        window.anims();
    };

    window.addEventListener('load', init);

}, false);
